import { useEffect, useState } from "react";
import AddAddressModal from "./AddAddressModal";
import { 
    getCustomerDeliveriesAddressList, 
    addCustomerDeliveryAddress, 
    deleteCustomerDeliveryAddress, 
    updateCustomerDeliveryAddress 
} from "../../../api/CustomerDeliveries";

type Address = {
    id: number;
    name: string;
    phone: string;
    address: string;
    province: string;
    district: string;
    ward: string;
    is_default: boolean;
};

export default function DeliveryAddressTab() {
    const [openModal, setOpenModal] = useState(false);
    const [addresses, setAddresses] = useState<Address[]>([]);
    const [editingAddress, setEditingAddress] = useState<Address | null>(null);

    const fetchAddresses = async () => {
        try {
            const response = await getCustomerDeliveriesAddressList();
            if (response.status) {
                setAddresses(response.data.items.map(item => ({
                    ...item,
                    is_default: !!item.is_default
                })));
            }
        } catch (error) {
            console.error("Failed to fetch addresses", error);
        }
    };

    useEffect(() => {
        fetchAddresses();
    }, []);

    const setDefault = async (id: number) => {
        const addr = addresses.find(a => a.id === id);
        if (addr) {
            try {
                await updateCustomerDeliveryAddress(id, {
                    ...addr,
                    //is_default: true as any // API might need this or have a separate endpoint, but following the provided updateCustomerDeliveryAddress
                });
                fetchAddresses();
            } catch (error) {
                console.error("Failed to set default address", error);
            }
        }
    };

    const removeAddress = async (id: number) => {
        if (window.confirm("Bạn có chắc chắn muốn xóa địa chỉ này?")) {
            try {
                await deleteCustomerDeliveryAddress(id);
                fetchAddresses();
            } catch (error) {
                console.error("Failed to delete address", error);
            }
        }
    };

    const handleAddOrUpdate = async (data: any) => {
        try {
            if (editingAddress) {
                await updateCustomerDeliveryAddress(editingAddress.id, data);
            } else {
                await addCustomerDeliveryAddress(data);
            }
            setOpenModal(false);
            setEditingAddress(null);
            fetchAddresses();
        } catch (error) {
            console.error("Failed to save address", error);
        }
    };

    return (
        <div
            className="MuiTabPanel-root styles_tab_panel__NZzZm"
            role="tabpanel"
            aria-labelledby="mui-p-91148-T-6"
            id="mui-p-91148-P-6"
        >
            <div className="MuiGrid-root form-delivery-info-container MuiGrid-container MuiGrid-spacing-xs-2">
                {addresses.map(item => (
                    <div
                        key={item.id}
                        className="MuiGrid-root delivery-card-wrapper MuiGrid-item MuiGrid-grid-md-6"
                        style={{ width: "100%" }}
                    >
                        <div className="styles_wrapCard__HThZ0">
                            <div className="styles_cardHeader__pAOU_">
                                <p className="MuiTypography-root styles_cardTitle__TEgBI delivery-card-title MuiTypography-body1">
                                    {item.is_default ? "Địa chỉ mặc định" : "Địa chỉ"}
                                </p>

                                <div className="delivery-card-actions" style={{ display: "flex" }}>
                                    <button
                                        className="MuiButtonBase-root MuiIconButton-root delete-tooltip delete-address-btn"
                                        onClick={() => removeAddress(item.id)}
                                        type="button"
                                        title="Xóa"
                                    >
                                        <span className="MuiIconButton-label"><svg className="MuiSvgIcon-root delete-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM9 9h6c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1zm6.5-5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z"></path></svg></span>
                                    </button>

                                    <button
                                        className="MuiButtonBase-root MuiIconButton-root edit-tooltip edit-address-btn"
                                        onClick={() => {
                                            setEditingAddress(item);
                                            setOpenModal(true);
                                        }}
                                        type="button"
                                        title="Sửa"
                                    >
                                        <span className="MuiIconButton-label"><svg className="MuiSvgIcon-root edit-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"></path></svg></span>
                                    </button>

                                    {!item.is_default && (
                                        <button
                                            className="MuiButtonBase-root MuiIconButton-root set-default-tooltip set-default-btn"
                                            onClick={() => setDefault(item.id)}
                                            type="button"
                                            title="Đặt làm mặc định"
                                        >
                                            <span className="MuiIconButton-label"><svg className="MuiSvgIcon-root location-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"></path><circle cx="12" cy="9" r="2.5"></circle></svg></span>
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="styles_content__hI7MQ">
                                <div className="MuiGrid-root delivery-info-container MuiGrid-container MuiGrid-spacing-xs-1">
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-3">
                                        <p className="MuiTypography-root styles_subTitle__e1fVQ name-label MuiTypography-body1">Tên:</p>
                                    </div>
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9">
                                        <p className="MuiTypography-root MuiTypography-body1">
                                            {item.name}
                                        </p>
                                    </div>

                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-3">
                                        <p className="MuiTypography-root styles_subTitle__e1fVQ name-label MuiTypography-body1">
                                            Số điện thoại:
                                        </p>
                                    </div>
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9">
                                        <p className="MuiTypography-root MuiTypography-body1">
                                            {item.phone}
                                        </p>
                                    </div>

                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-3">
                                        <p className="MuiTypography-root styles_subTitle__e1fVQ name-label MuiTypography-body1">
                                            Địa chỉ:
                                        </p>
                                    </div>
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-9">
                                        <p className="MuiTypography-root MuiTypography-body1">
                                            {item.address}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {/* ADD NEW */}
                <div
                    className="MuiGrid-root add-card-wrapper MuiGrid-item MuiGrid-grid-md-6"
                    style={{ width: "100%" }}
                >
                    <div className="styles_container__2h3uc">
                        <div className="styles_addCard__nPr4_">
                            <button
                                className="MuiButtonBase-root MuiIconButton-root add-address-btn"
                                onClick={() => setOpenModal(true)}
                                type="button"
                            >
                                <span className="MuiIconButton-label"><svg className="MuiSvgIcon-root add-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true" style={{ color: "var(--primary-color)" }}><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></svg></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* MODAL */}
            {openModal && (
                <AddAddressModal
                    onClose={() => {
                        setOpenModal(false);
                        setEditingAddress(null);
                    }}
                    onSubmit={handleAddOrUpdate}
                    initialData={editingAddress}
                />
            )}
        </div>
    );
}
